<template>
    <v-expand-transition>
        <!-- 상단 system bar -->
        <v-system-bar 
            v-if="sysBarInfo.status"
            app
            dark
            window
            height="35"
            lights-out
            :class="[sysBarInfo.inset?'no-print custom-system-bar':'no-print no-inset']"
            :color="sysBarInfo.color">
            <v-icon class="mr-4">check</v-icon>
            <span class="text-body-2 font-weight-bold white--text">
                {{sysBarInfo.message}}
            </span>
            <v-spacer></v-spacer>
            <v-icon 
                @click.prevent="close">
                mdi-close
            </v-icon>
        </v-system-bar> 
        
        <!-- badge와 alert바 이용 -->
        <!-- <v-badge
            v-if="sysBarStatus"
            avatar
            bordered
            overlap
            left
            icon="check"
            color="success"
            class="icon"
        >
            <v-alert
                v-model="sysBarStatus"
                dismissible
                color="success"
                dark
                width="400"
                elevation="24"
            >
                <span class="white--text text-body-2">
                    {{sysBarMessage}}
                </span>
            </v-alert>
        </v-badge> -->
    </v-expand-transition>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    name: 'SystemBar',
    data:() => ({
        currentPage: '',
    }),
    computed: {
        ...mapGetters({
            sysBarInfo: 'SYSTEM_BAR_INFO'
        })
    },
    methods: {
        close() {
            this.$store.commit('CLOSE_SYSTEM_BAR')
        }
    }
}
</script>

<style lang="scss" scoped>
    .icon {
        position: fixed;
        bottom: 20px;
        right: 40px;
    }
    .custom-system-bar {
        width: calc(100% - 64px);
        margin-left: 64px;
        z-index: 999;
    }
    .no-inset {
        z-index: 999;
    }
</style>


// WEBPACK FOOTER //
// src/components/commons/SystemBar.vue